/**
 * Hero image style subhero banner
 *
 * Copyright (c) 2020 Coursera
 * Author: Kelvin Nguyen
 */
import React, { useMemo } from 'react'
import cx from 'classnames'
import Grid from '@material-ui/core/Grid'
import CTAHeader, { CTAHeaderPropTypes } from 'components/CTAHeader'
import SectionWrapper, { SectionWrapperPropTypes } from 'components/SectionWrapper'
import styles from './SubHero.module.scss'

const SubHero = ({
  className, flipped, backgroundImage, backgroundColor, children, ...props
}) => {
  const Content = useMemo(() => {
    const CallToAction = (
      <Grid
        item
        lg={5}
        md={6}
        xs={12}>
        <CTAHeader
          align="left"
          className={cx(styles.header)}
          {...props}
          centerDevice={false}
          titleSettings={{
            ...props?.titleSettings,
            className: cx(styles.title),
          }} />
      </Grid>
    )

    const HeroImage = (
      <Grid
        className="p-0"
        lg={7}
        md={6}
        xs={12}
        item>
        <div
          className={cx(styles.backgroundImageWrapper)}
          style={{ backgroundImage: `url(${backgroundImage})` }} />
      </Grid>
    )

    const InnerContent = (
      <Grid
        className="p-0"
        lg={7}
        md={6}
        xs={12}
        item>
        <div className={cx(styles.backgroundImageWrapper)}>
          {children}
        </div>
      </Grid>
    )

    return (flipped) ? (
      <>
        { children ? InnerContent : HeroImage}
        {CallToAction}
      </>
    ) : (
      <>
        {CallToAction}
        { children ? InnerContent : HeroImage}
      </>
    )
  }, [backgroundImage, flipped, children, props])

  return (
    <SectionWrapper
      className={cx(className, styles.subHero)}
      backgroundColor={backgroundColor}>
      <Grid
        container
        direction="row"
        justify="center"
        alignItems="center"
        spacing={8}>
        {Content}
      </Grid>
    </SectionWrapper>
  )
}

// const SubHero = ({
//   headline, content, image, color,
// }) => {
//   const Header = useMemo(() => (
//     <h1 className="headline">{headline}</h1>
//   ), [headline])

//   const Subheader = useMemo(() => (
//     <div className="subheader">{content}</div>
//   ), [content])

//   const HeroImage = useMemo(() => (
//     <div
//       className="background-image-wrapper"
//       style={{ backgroundImage: `url(${image})` }}
//       alt={headline} />
//   ), [headline, image])

//   const subheroClass = cx(styles(['subhero']), {
//     [color]: true,
//   })

//   return (
//     <section className={subheroClass}>
//       <div className="wrapper">
//         <div className="container">
//           <div className="row">
//             <div className="col-xs-12 col-sm-12 col-md-12 col-lg-5">
//               <div className="hero-content">
//                 {Header}
//                 {Subheader}
//               </div>
//             </div>
//           </div>
//         </div>
//         {HeroImage}
//       </div>
//     </section>
//   )
// }

SubHero.propTypes = {
  ...SectionWrapperPropTypes,
  ...CTAHeaderPropTypes,
}

export default SubHero
